import { useState, useEffect } from 'react';

export default function useTimedError(initialError = null, timeout = 5000) {
    const [error, setError] = useState(initialError);

    useEffect(() => {
        if (error) {
            setTimeout(() => {
                setError(null);
            }, timeout);
        }
    }, [error, timeout, setError]);

    return [error, setError];
}